import { ca } from '@cian/analytics';

interface ITrackShowPhoneParams {
  gaLabel: string;
  newbuildingId: number;
  isBuilder: boolean;
}

export const trackShowPhone = ({ gaLabel, newbuildingId, isBuilder }: ITrackShowPhoneParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_jk_card_chats',
    label: gaLabel,
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
      },
    ],
    page: {
      extra: {
        pageType: 'JK',
        seller_type: isBuilder ? 'builders' : 'agents',
        pageTypeJK: 'Normal',
      },
    },
  });
};
